import Logo from "../resources/logo.svg";
import antrag from "../resources/kontakt/Mitgliedsantrag.pdf";
import downloadIcon from "../resources/kontakt/download.svg";


function Kontakt() {

    return (
        <div className="Kontakt">

            <div className="col-md-8">
                <div className="pagecontent">
                    <p>AUFTRITTSBUCHUNG</p>
                </div>

                {/* <div className="row justify-content-md-center kontaktDiv"> */}
                {/* <img alt="Bild1" className="col-md-4 inlineImage" src={groga}></img> */}
                <div className="verticalDiv col-sm-6">
                    <p className="heading_midsize ">Großer Hofstaat</p>
                    <span>Marlene Guppenberger & Theresa Reißner<br />
                        Anfragen über Social Media oder als Email an:<br />
                        <b>fasching@eggspatzen.de </b></span>
                </div>
                {/* </div> */}

                {/* <div className="row justify-content-md-center kontaktDiv"> */}
                <div className="verticalDiv col-sm-6">
                    <p className="heading_midsize">Kleiner Hofstaat</p>
                    <p className="">Gerda Müller</p>
                    <p className="">0 84 24 / 5 27</p>
                </div>
                {/* <img alt="Bild1" className="col-md-4 inlineImage" src={kiga}></img> */}

                {/* </div> */}


                {/* <div className="row justify-content-md-center kontaktDiv"> */}
                {/* <img alt="Bild1" className="col-md-4 inlineImage" src={romo}></img> */}
                <div className="verticalDiv col-sm-6">
                    <p className="heading_midsize">Rosenmontag</p>
                    <span style={{ textAlign: "left" }}>Anmeldung über Email an: <br />
                        <b>rosenmontag@eggspatzen.de </b> <br />
                        Der Umzug beginnt um 13:30 Uhr. Die Aufstellung der <br />Teilnehmenden beginnt um 13:00 Uhr. </span>
                </div>
                {/* </div> */}

                {/* <div className="row justify-content-md-center kontaktDiv"> */}
                <div className="verticalDiv col-sm-6">
                    <p className="heading_midsize">Mitgliedsantrag</p>
                  
                    <span className="">Um Mitglied im Verein zu werden einfach den Mitgliedantrag <br />ausfüllen und an fasching@eggspatzen.de senden.</span>
                    <a href={antrag} download="Mitgliedsantrag_Eggspatzen.pdf" className="download_link">
                        <p>
                            <img src={downloadIcon}></img> 
                            Mitgliedantrag herunterladen
                        </p>
                    </a>
                </div>
                {/* <img alt="Bild1" className="col-md-4 inlineImage" src={romo}></img> */}


                

            </div>

            {/* </div> */}

            <video className="col-sm-4 videoVertical" loop autoPlay muted playsInline>
                <source src="https://storage.googleapis.com/eggspatzen-data-bucket/showteil2025.MP4" type="video/mp4" />
            </video>
            <div className="row justify-content-sm-center" style={{ textAlign: 'center' }}>
                    <img src={Logo} className="imageResize"></img>
                </div>

        </div>
    );
}

export default Kontakt;